/**
 * @desc 查询冗余库存
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(sku: string | number, options?: any) {
  return updateResponse(
    http(URL + `/wms/frozenCreateOrder/redundancyStockQuery/${sku}`, {
      method: "GET",

      ...options,
    }),
  );
}
